import { styled } from "@mui/material/styles";

export const Wrapper = styled("header")(() => ({
  marginBottom: "1.07rem",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",

  flexWrap: "wrap",
  gap: 8,
}));

export const WrapperLeftSide = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "1.07rem",
}));

export const Title = styled("span")(() => ({
  fontSize: "1.2rem",
  color: "#465869",
  fontWeight: 700,
  lineHeight: "1.2rem",
  fontFamily: "Manrope",
}));
